import { userApis } from '@apis/userApis';
import { createUseQuery } from '@hooks/createUseQuery';
import { StatusNotHandled } from 'tyrann-io';

export const useUser = createUseQuery(
  ['/user/'],
  () => () =>
    userApis
      .get('/user/', {})
      .then((r) => {
        return r['200']!;
      })
      .catch((e) => {
        if (e instanceof StatusNotHandled && [401, 403].includes(e.status)) {
          return null;
        }
        throw e;
      }),
  {
    staleTime: 30000,
  },
);
